/* ============================================================
   PETSLIFY RESOURCES — Article TOC
   Scans article body for H2 elements and builds a clickable
   table of contents. Hides TOC if fewer than 2 headings found.
   Scoped to .article-resources only.
   ============================================================ */

(function () {
  'use strict';

  function initArticleTOC() {
    var tocContainer = document.querySelector('[data-article-toc]');
    var tocList = document.querySelector('[data-article-toc-list]');
    var content = document.querySelector('.article-resources__content');

    // If any required element is missing, do nothing (we're not on a Resources article)
    if (!tocContainer || !tocList || !content) {
      return;
    }

    // Find all H2 headings in the article body
    var headings = content.querySelectorAll('h2');

    // If fewer than 2 H2 headings, hide the TOC entirely
    if (headings.length < 2) {
      tocContainer.setAttribute('hidden', '');
      return;
    }

    // Clear the placeholder
    tocList.innerHTML = '';

    // Build the TOC
    headings.forEach(function (heading, index) {
      // Generate a stable ID for anchor linking
      var headingId = heading.id;
      if (!headingId) {
        headingId = 'section-' + (index + 1) + '-' + slugify(heading.textContent);
        heading.id = headingId;
      }

      // Create list item with anchor link
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + headingId;
      a.textContent = heading.textContent;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(headingId);
        if (target) {
          // Offset for fixed headers if any (60px buffer)
          var offsetTop = target.getBoundingClientRect().top + window.pageYOffset - 60;
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
          // Update URL hash without jumping
          if (history.pushState) {
            history.pushState(null, null, '#' + headingId);
          }
        }
      });
      li.appendChild(a);
      tocList.appendChild(li);
    });
  }

  // Helper: turn heading text into a URL-safe slug
  function slugify(text) {
    return text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '') // remove punctuation
      .replace(/[\s_-]+/g, '-') // collapse whitespace and underscores
      .replace(/^-+|-+$/g, '') // trim leading/trailing hyphens
      .substring(0, 60); // cap length
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArticleTOC);
  } else {
    initArticleTOC();
  }
})();